export default "__VITE_ASSET__wL8HNw$L__"